<div id="ng-app-wrapper">
  <div class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-1 fusion-parallax-none
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
    " style="
      background-color: rgba(255, 255, 255, 0);
      background-image: url('/wp-content/uploads/2015/12/home-244125289-1024x630.jpg');
      background-position: center top;
      background-repeat: no-repeat;
      padding-top: 150px;
      padding-right: 30px;
      padding-bottom: 0px;
      padding-left: 30px;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
    ">
    <div class="fusion-builder-row fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-0
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        " style="margin-top: 0px; margin-bottom: 0px">
        <div class="fusion-column-wrapper" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 100px"></div>
          <div class="
              fusion-section-separator
              section-separator
              big-half-circle
              fusion-section-separator-with-offset
            " style="
              padding: 0;
              margin-left: calc((100vw - 100%) / -2);
              margin-right: calc((100vw - 100%) / -2);
            ">
            <svg class="fusion-big-half-circle-candy" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%"
              height="100" viewBox="0 0 100 100" preserveAspectRatio="none" style="fill: #ffffff; padding: 0">
              <path d="M0 100 C40 0 60 0 100 100 Z"></path>
            </svg>
          </div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <style type="text/css">
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
      color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
      color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
    .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a {
      border-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 .pagination .current {
      border-color: #ffa626;
      background-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a,
    .fusion-fullwidth.fusion-builder-row-1 .fusion-date-and-formats .fusion-format-box,
    .fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
    .fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
      color: #ffa626;
    }

    #main .fusion-fullwidth.fusion-builder-row-1 .post .blog-shortcode-post-title a:hover {
      color: #ffa626;
    }
  </style>
  <div class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-2
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
    " style="
      background-color: rgba(255, 255, 255, 0);
      background-position: center center;
      background-repeat: no-repeat;
      padding-top: 0px;
      padding-right: 30px;
      padding-bottom: 0px;
      padding-left: 30px;
      margin-top: -150px;
    ">
    <div class="fusion-builder-row fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-1
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        " style="margin-top: 0px; margin-bottom: 25px">
        <div class="fusion-column-wrapper" style="
            background-color: var(--ng-app-mid-grey-color);
            padding: 50px 30px 30px 30px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">
          <div class="
              fusion-tabs fusion-tabs-1
              clean
              vertical-tabs
              icon-position-left
            ">
            <style type="text/css">
              #ng-app-wrapper .fusion-tabs.fusion-tabs-1.clean .nav-tabs li a.tab-link {
                border-color: rgba(245, 245, 245, 0);
              }

              .fusion-tabs.fusion-tabs-1 .nav-tabs li a.tab-link {
                background-color: var(--ng-app-light-grey-color);
              }

              .fusion-tabs.fusion-tabs-1 .nav-tabs li.active a.tab-link,
              .fusion-tabs.fusion-tabs-1 .nav-tabs li.active a.tab-link:hover,
              .fusion-tabs.fusion-tabs-1 .nav-tabs li.active a.tab-link:focus {
                background-color: #ffa626;
              }

              .fusion-tabs.fusion-tabs-1 .nav-tabs li a:hover {
                background-color: #ffa626;
                border-top-color: #ffa626;
              }

              /* .fusion-tabs.fusion-tabs-1 .tab-pane {
                    background-color: #ffa626;
                } */

              .fusion-tabs.fusion-tabs-1 .nav,
              .fusion-tabs.fusion-tabs-1 .nav-tabs,
              .fusion-tabs.fusion-tabs-1 .tab-content .tab-pane {
                border-color: rgba(245, 245, 245, 0);
              }

              a#tab-ng-app-logout {
                border: 2px solid !important;
              }

              #user-name-div:hover {
                color: var(--ng-app-theme-yellow-color);
              }
            </style>
            <div class="nav">
              <ul class="nav-tabs">
                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li class="active">
                  <a class="tab-link" data-toggle="tab" id="fusion-tab-dashboard" (click)="openTab('dashboard')">
                    <h4 class="fusion-tab-heading">DASHBOARD</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <a class="tab-link" data-toggle="tab" id="fusion-tab-lemiegare" (click)="openTab('tenders')">
                    <h4 class="fusion-tab-heading">LE MIE GARE</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <a class="tab-link" data-toggle="tab" id="fusion-tab-lemiepartecipazioni"
                    (click)="openTab('myParticipations')">
                    <h4 class="fusion-tab-heading">LE MIE PARTECIPAZIONI</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <a class="tab-link" data-toggle="tab" id="fusion-tab-imieiannunci" 
                    (click)="openTab('announcements')">
                    <h4 class="fusion-tab-heading">I MIEI ANNUNCI</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <a class="tab-link" data-toggle="tab" id="fusion-tab-profilo" (click)="openTab('profile')">
                    <h4 class="fusion-tab-heading">PROFILO</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <a class="tab-link" data-toggle="tab" id="fusion-tab-carta-di-credito"
                    (click)="openTab('paymentMethod')">
                    <h4 class="fusion-tab-heading">CARTA DI CREDITO</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <a class="tab-link" data-toggle="tab" id="fusion-tab-pacchettiprepagati"
                    (click)="openTab('prepaidPackets')">
                    <h4 class="fusion-tab-heading">ABBONAMENTI</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <a class="tab-link" data-toggle="tab" id="tab-ng-app-logout" (click)="logout()">
                    <h4 class="fusion-tab-heading">ESCI</h4>
                  </a>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->

                <li>
                  <div class="fusion-li-item-content" id="user-name-div" style="
                      margin-top: 10vh;
                      text-align: center;
                      font-size: 17px;
                      padding-left: 1px;
                      font-weight: 500;
                    ">
                    <p style="margin-bottom: 0">Benvenuto</p>
                    <p>{{ userName }}</p>
                  </div>
                </li>

                <!-- /////////////////////////////////////////////////////////////////////////////////////////////// -->
              </ul>
            </div>

            <!-- /////////////////////////////////////////////////////////////////////////////////////////////////// -->
            <!-- /////////////////////////////////////////////////////////////////////////////////////////////////// -->

            <div class="tab-content">
              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li class="active">
                    <a class="tab-link" data-toggle="tab" id="mobile-fusion-tab-dashboard" (click)="openDashboard()">
                      <h4 class="fusion-tab-heading">DASHBOARD</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-dashboard" *ngIf="loadDashboard">
                <app-dashboard></app-dashboard>
              </div>

              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li>
                    <a class="tab-link" data-toggle="tab" id="mobile-fusion-tab-lemiegare" (click)="openMyTenders()">
                      <h4 class="fusion-tab-heading">LE MIE GARE</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-tenders" *ngIf="loadMyTenders">
                <app-tenders></app-tenders>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-tender-detail"
                *ngIf="loadTenderDetail">
                <app-tender-detail [tenderId]="tenderId"></app-tender-detail>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-tender-questions-and-answers"
                *ngIf="loadTenderQuestionsAndAnswers">
                <app-questions-and-answers [tenderId]="tenderId" [participationId]="participationId"
                  [tenderTitle]="tenderTitle" [openedFrom]="openedFrom" [editable]="editable">
                </app-questions-and-answers>
              </div>

              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li>
                    <a class="tab-link" data-toggle="tab" id="mobile-fusion-tab-lemiepartecipazioni"
                      (click)="openMyPartecipations()">
                      <h4 class="fusion-tab-heading">LE MIE PARTECIPAZIONI</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-participations"
                *ngIf="loadMyPartecipations">
                <app-tenders [isParticipations]="loadMyPartecipations"></app-tenders>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-participation-detail"
                *ngIf="loadParticipationDetail">
                <app-participation-detail [tenderId]="tenderId"></app-participation-detail>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-participation-questions-and-answers"
                *ngIf="loadParticipationQuestionsAndAnswers">
                <app-questions-and-answers [tenderId]="tenderId" [participationId]="participationId"
                  [tenderTitle]="tenderTitle" [openedFrom]="openedFrom" [editable]="editable">
                </app-questions-and-answers>
              </div>

              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-announcements"
                *ngIf="loadMyAnnouncements">
                <app-announcements></app-announcements>
              </div>
              <div
                class="tab-pane fade fusion-clearfix in active"
                id="tab-ng-app-announcement-detail"
                *ngIf="loadAnnouncementDetail"
								>
                <app-announcement-detail [announcementId]="tenderId"></app-announcement-detail>
              </div>

              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li>
                    <a class="tab-link" data-toggle="tab" id="mobile-fusion-tab-profilo" (click)="openProfile()">
                      <h4 class="fusion-tab-heading">PROFILO</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-profile" *ngIf="loadProfile">
                <app-profile [tenderId]="tenderId" [fromTender]="fromTender" [fromClusterTender]="fromClusterTender" 
                             [fromPrepaidPacket]="fromPrepaidPacket"
                             [fromPrepaidPacketBuy]="fromPrepaidPacketBuy" [fromQuoteBuy]="fromQuoteBuy"></app-profile>
              </div>

              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li>
                    <a class="tab-link" data-toggle="tab" id="mobile-fusion-tab-carta-di-credito"
                      (click)="openPaymentMethod()">
                      <h4 class="fusion-tab-heading">CARTA DI CREDITO</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-ng-app-payment-methods"
                *ngIf="loadPaymentMethod">
                <app-payment-methods [fromClusterTender]="fromClusterTender" [tenderId]="tenderId" [fromTender]="fromTender"
                   [isTenderPacket]="isTenderPacket"
                  [fromPrepaidPacketBuy]="fromPrepaidPacketBuy" [fromQuoteBuy]="fromQuoteBuy"></app-payment-methods>
              </div>

              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li>
                    <a class="tab-link" data-toggle="tab" id="mobile-fusion-tab-pacchettiprepagati"
                      (click)="openPrepaidPackets()">
                      <h4 class="fusion-tab-heading">ABBONAMENTI</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-pane fade fusion-clearfix in active" id="tab-bdd3f5786603fc5fd7c"
                *ngIf="loadPrepaidPackets">
                <!-- <app-prepaid-packets [fromTender]="fromTender" [fromQuoteBuy]="fromQuoteBuy"></app-prepaid-packets> -->
                <app-prepaid-packets></app-prepaid-packets>
              </div>

              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li>
                    <a class="tab-link" data-toggle="tab" id="mobile-fusion-tab-imieiannunci"
                      (click)="openMyAnnouncements()">
                      <h4 class="fusion-tab-heading">I MIEI ANNUNCI</h4>
                    </a>
                  </li>
                </ul>
              </div>
              
              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->

              <div class="nav fusion-mobile-tab-nav">
                <ul class="nav-tabs">
                  <li>
                    <a class="ng-logout tab-link" data-toggle="tab" id="tab-ng-app-logout" (click)="logout()">
                      <h4 class="fusion-tab-heading">ESCI</h4>
                    </a>
                  </li>
                </ul>
              </div>

              <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->
            </div>
          </div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <style type="text/css">
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
      color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
      color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 .pagination a.inactive:hover,
    .fusion-fullwidth.fusion-builder-row-2 .fusion-filters .fusion-filter.fusion-active a {
      border-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 .pagination .current {
      border-color: #ffa626;
      background-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 .fusion-filters .fusion-filter.fusion-active a,
    .fusion-fullwidth.fusion-builder-row-2 .fusion-date-and-formats .fusion-format-box,
    .fusion-fullwidth.fusion-builder-row-2 .fusion-popover,
    .fusion-fullwidth.fusion-builder-row-2 .tooltip-shortcode {
      color: #ffa626;
    }

    #main .fusion-fullwidth.fusion-builder-row-2 .post .blog-shortcode-post-title a:hover {
      color: #ffa626;
    }
  </style>
</div>

<app-modal #fromTenderModal>
  <ng-template #header>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>{{ modalMessage }}</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-button-wrapper fusion-aligncenter">
      <style type="text/css">
        .fusion-button.button-7 {
          border-radius: 0px;
        }
      </style><a (click)="closeFromTenderModal()" class="
          fusion-button
          button-flat
          fusion-button-default-size
          button-default button-7
          fusion-button-default-span fusion-button-default-type
        " target="_self"><span class="fusion-button-text">OK</span></a>
    </div>
    <div class="fusion-clearfix"></div>
  </ng-template>
</app-modal>